import React from 'react';

interface HeatMapProps {
  imageUrl: string;
}

const HeatMap: React.FC<HeatMapProps> = ({ imageUrl }) => {
  return (
    <div className="relative aspect-video">
      <img 
        src={imageUrl} 
        alt="Heat map visualization" 
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-red-500/30 via-yellow-500/30 to-green-500/30 mix-blend-multiply" />
    </div>
  );
};

export default HeatMap;